const MIN_STRIPE_INVOICE_SUM = 0.5;
export default (revenue: number) =>
  revenue > 0 ? Math.max(MIN_STRIPE_INVOICE_SUM, revenue) : revenue;
